/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicedownload1Inputs */

const en_invoicedownload1 = /** @type {(inputs: Invoicedownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

const de_invoicedownload1 = /** @type {(inputs: Invoicedownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

/**
* | output |
* | --- |
* | "PDF" |
*
* @param {Invoicedownload1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicedownload1 = /** @type {((inputs?: Invoicedownload1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicedownload1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicedownload1(inputs)
	return de_invoicedownload1(inputs)
});
export { invoicedownload1 as "invoiceDownload" }